import store from "../../store";
import NProgress from 'nprogress';


export default function ({next, to, router}) {
    if (! to.query.hasOwnProperty('continue')) {
        return router.push({name: 'Applications'});
    }

    // Mamy przesłany kontekst
    // I zapisywana jest do magazynu danych
    let continueUrl = to.query.continue;

    store.dispatch('setContextApplication', {continueUrl})
        .finally(() => {
            NProgress.inc();
            next();
        })
}
